import React from "react"

export const AboutWebsite = () => {
  return (
    <div className="about-website-wrapper">
      <h3 className="about-website-heading">About</h3>
      <p>
        Frontendroom is primary focused on content related to user interface
        related development. This website is monetized with ads.
      </p>
    </div>
  )
}
